import React from "react"
import { AutoSizer, List } from "react-virtualized"

import { Account, Schedule, Viewer } from "@shared/contexts"

import User from "./User"

interface Props {
  users: Viewer[]
  account: Account
  schedule: Schedule | null
  handleAction: Function
  searchKeyword: string
}

function Users({
  users,
  account,
  schedule,
  handleAction,
  searchKeyword,
}: Props) {
  function rowRenderer({ key, index, style }: any) {
    const user = users[index]
    if (user.nickname?.indexOf(searchKeyword) === -1) return null

    return (
      <li key={key} style={style}>
        <User
          viewer={user}
          account={account}
          schedule={schedule}
          handleAction={handleAction}
        />
      </li>
    )
  }

  return (
    <ul>
      <AutoSizer disableHeight>
        {({ width }) => (
          <List
            searchKeyword={searchKeyword}
            width={width}
            height={175}
            rowCount={users.length}
            rowHeight={32}
            rowRenderer={rowRenderer}
          />
        )}
      </AutoSizer>
    </ul>
  )
}

export default Users
